import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { useQueries } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../hooks/useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../../../hooks/api/v2/apiV2Request";
import { ServerStateKeys } from "../../../hooks/api/v2/ServerStateKeys";

export const usePaidOrders = (orderIds: number[]) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQueries({
    queries: orderIds.map((orderId) => ({
      queryKey: [user?.uid, business?.id, ServerStateKeys.Orders, orderId],
      queryFn: () =>
        apiV2Request({
          user,
          business,
          method: "get",
          path: `orders/${orderId}`,
        }).then((data) => apiV2AssertResponse<OrderGetResponseType>(data).data),
      ...getDefaultQueryOptionsV2({
        user,
        business: business,
        overrideOptions: { enabled: orderId > 0 },
      }),
    })),
  });
};
